(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-signature-data]').textContent);
    const select = root.querySelector('[data-signature-variant]');
    const buttons = [...root.querySelectorAll('[data-signature-option]')];
    const items = [...root.querySelectorAll('[data-signature-image]')];
    const gallery = root.querySelector('[data-signature-gallery]');
    const media = root.querySelector('[data-signature-media]');
    const bar = root.querySelector('[data-signature-bar]');
    let selected = data.variants.find(v => String(v.id) === select.value) || data.variants[0];
    let options = [...selected.options];
    function update(writeUrl = false) {
      // Keep the same view when changing metal; each gallery follows the same image order.
      const mediaScrollTop = media.scrollTop;
      const galleryScrollLeft = gallery.scrollLeft;
      selected = data.variants.find(v => v.options.every((o,i) => o === options[i]));
      buttons.forEach(b => b.setAttribute('aria-pressed', String(options[Number(b.dataset.signatureOption)] === b.dataset.value)));
      select.value = selected ? String(selected.id) : '';
      root.querySelectorAll('[data-signature-price]').forEach(el => el.textContent = selected ? new DOMParser().parseFromString(data.prices[selected.id], 'text/html').body.textContent : data.unavailable);
      root.querySelectorAll('[data-signature-submit]').forEach(b => { b.disabled = !selected?.available; b.textContent = !selected ? data.unavailable : selected.available ? data.add : data.soldOut; });
      const color = data.isSignatureStuds ? options[0].toLocaleLowerCase('nb-NO') : '';
      const summary = root.querySelector('[data-signature-summary]');
      if (summary) summary.textContent = data.isSignatureStuds ? `14K ${color} · Labdyrkede diamanter · ${data.studWeight} ct per øredobb` : [data.summaryPrefix, data.hasOnlyDefaultVariant ? '' : options.join(' / ')].filter(Boolean).join(' · ');
      const matched = color ? items.filter(item => item.dataset.alt.includes(color)) : [];
      items.forEach(item => item.hidden = matched.length > 0 && !matched.includes(item));
      media.scrollTop = mediaScrollTop;
      gallery.scrollLeft = galleryScrollLeft;
      if (writeUrl && selected) { const url = new URL(location.href); url.searchParams.set('variant', selected.id); history.replaceState(history.state, '', url); }
    }
    buttons.forEach(b => b.addEventListener('click', () => { options[Number(b.dataset.signatureOption)] = b.dataset.value; update(true); }));
    select.hidden = true;
    function geometry() {
      const header = document.querySelector('.shopify-section-group-header-group');
      const preview = document.querySelector('#PBarNextFrame');
      const h = header?.getBoundingClientRect().height || 84;
      const p = preview ? 64 : 0;
      root.style.setProperty('--ij-header', `${h}px`);
      root.style.setProperty('--ij-preview-height', `${p}px`);
      root.style.setProperty('--ij-bar-height', `${bar.getBoundingClientRect().height}px`);
      bar.style.bottom = `${p}px`;
    }
    const observer = new ResizeObserver(geometry);
    observer.observe(bar);
    const header = document.querySelector('.shopify-section-group-header-group');
    if (header) observer.observe(header);
    window.addEventListener('resize', geometry, {passive:true});
    window.addEventListener('load', geometry, {once:true});
    root.querySelector('form').addEventListener('submit', event => { if (!selected?.available) event.preventDefault(); });
    update(); geometry();
  }
  document.querySelectorAll('[data-futur-signature]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-futur-signature]').forEach(init));
})();
